(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["festive_photo_carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('festive-photo-carousel')) {
    customElements.define('festive-photo-carousel', class extends HTMLElement {
      connectedCallback() {
        this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-card]'));
        this.active = 0;
        this.paused = false;
        this.visible = true;
        var self = this;
        var stage = this.querySelector('[data-stage]');
        this.querySelector('[data-prev]').addEventListener('click', function () { self.go(-1); });
        this.querySelector('[data-next]').addEventListener('click', function () { self.go(1); });
        this.cards.forEach(function (card, i) {
          card.addEventListener('click', function (event) {
            if (event.target.closest('a') && i === self.active) return;
            if (i !== self.active) { event.preventDefault(); self.set(i); }
          });
        });
        var startX = null;
        stage.addEventListener('pointerdown', function (event) { startX = event.clientX; self.paused = true; });
        stage.addEventListener('pointerup', function (event) {
          if (startX !== null && Math.abs(event.clientX - startX) > 40) self.go(event.clientX < startX ? 1 : -1);
          startX = null;
        });
        stage.addEventListener('pointercancel', function () { startX = null; });
        this.addEventListener('mouseenter', function () { self.paused = true; });
        this.addEventListener('mouseleave', function () { self.paused = false; });
        this.addEventListener('focusin', function () { self.paused = true; });
        this.addEventListener('focusout', function () { self.paused = false; });
        this.addEventListener('touchend', function () { setTimeout(function () { self.paused = false; }, 4000); });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(function (entries) { self.visible = entries[0].isIntersecting; });
          this.observer.observe(this);
        }
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var interval = Math.max(2, Number(this.dataset.interval) || 4) * 1000;
        if (this.dataset.autoplay !== 'false' && !reduce && this.cards.length > 1) {
          this.timer = setInterval(function () { if (!self.paused && self.visible) self.go(1); }, interval);
        }
        this.layout();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.observer) this.observer.disconnect();
      }
      go(step) { this.set((this.active + step + this.cards.length) % this.cards.length); }
      set(index) { this.active = index; this.layout(); }
      layout() {
        var n = this.cards.length;
        var active = this.active;
        var offsets = [0, 0.64, 1.08, 1.46];
        var scales = [1, 0.88, 0.76, 0.64];
        var opacities = [1, 0.85, 0.6, 0.35];
        this.cards.forEach(function (card, i) {
          var o = ((i - active + n + Math.floor(n / 2)) % n) - Math.floor(n / 2);
          if (n % 2 === 0 && o === -Math.floor(n / 2)) o = Math.floor(n / 2);
          var a = Math.abs(o);
          var link = card.querySelector('a');
          if (a > 3) {
            card.style.opacity = '0';
            card.style.visibility = 'hidden';
            card.style.pointerEvents = 'none';
            card.style.zIndex = '0';
            card.style.transform = 'translate(-50%, -50%) translateX(calc(var(--w) * ' + (o < 0 ? -2 : 2) + ')) scale(0.5)';
            if (link) link.tabIndex = -1;
            return;
          }
          var sign = o < 0 ? -1 : 1;
          card.style.visibility = 'visible';
          card.style.pointerEvents = 'auto';
          card.style.opacity = String(opacities[a]);
          card.style.zIndex = String(10 - a);
          card.style.transform = 'translate(-50%, -50%) translateX(calc(var(--w) * ' + (sign * offsets[a]) + ')) scale(' + scales[a] + ')';
          if (link) link.tabIndex = a === 0 ? 0 : -1;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
